module.exports = __webpack_public_path__ + "img/1.365d5693.png";